import React, { useState } from "react";
import GiftBookImage from "../../assets/images/gift_book.jpg";
import "./index.scss";

const Banner = () => {
	const [shown, setShown] = useState(true);

	return (
		<div
			id="banner"
			className={`w-100 mx-auto row bg-secondary shadow-lg px-4 d-flex align-items-center ${
				shown ? "pt-3 pb-2" : ""
			}`}
		>
			{shown && (
				<>
					<div className="col-md-1"></div>
					<div id="gift-book" className="col-lg-1 col-md-2 col-sm-3 col-5">
						<img
							className="rounded border-white border"
							src={GiftBookImage}
							alt="Wisdom Gift Book"
						/>
					</div>
					<div className="col-lg-9 col-md-8 col-sm-9">
						<h5 className="mb-0 text-white">
							En Navidad, Wisdom te obsequia los gastos de envío. Ahorra
							comprando antes del <strong>31 de diciembre</strong>.
						</h5>
						<p className="mb-0 text-white">
							<strong className="text-info">Términos y condiciones:</strong>{" "}
							Promoción valida del 17 al 31 de diciembre de 2020, aplica
							únicamente para compras de contenidos impresos, contenidos y
							plataformas digitales realizadas por{" "}
							<strong>https://store.wisdom.net.co</strong>, sin cargo de gastos
							de envió a nivel nacional. Para compras realizadas entre el 18 y
							31 de diciembre, su entrega se programara a partir del 7 de enero
							del 2021. El comprador recibirá por correo electrónico la
							confirmación y validación de su compra.
						</p>
					</div>
				</>
			)}
			<div className={`col-12 text-center`}>
				<em
					className={`fas px-5 pointer fa-chevron-${
						shown ? "up" : "down pt-2 pb-2"
					}`}
					onClick={() => setShown(!shown)}
				/>
			</div>
		</div>
	);
};

export default Banner;
